export default "__VITE_ASSET__e749ce90__"